import React from 'react';
import FilterList from '../../../components/user/article/articleFilterList';
import Layout from '../../../components/layouts/verticalLayout';

const ArticleListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

ArticleListPage.propTypes = {};

export default ArticleListPage;
